<template>
  <div
    class="flex-column language"
    v-click-outside="onClickOutside"
    v-if="languageOptions.languages.length > 1 && (programName === 'Can Wgnr' || programName === 'Can CF')"
  >
    <div class="relative" @click="toggleMulti">
      {{ $t('language') }}
      <div v-if="showMulti" class="lang-container">
        <div v-for="language in languageOptions.languages" :key="language.code">
          <div
            @click="updateLangOption(language)"
            :class="{ lang: true, active: languageOptions.selectedLanguage.code === language.code }"
          >
            {{ language.name }}
          </div>
        </div>
      </div>
    </div>
    <Modal class="modal-screens" v-show="isModalOpen">
      <template v-slot:body class="body">
        {{ $t('change-language') }}
        <div class="modal-button-container">
          <button class="submit" @click="confirmLang">{{ $t('submit') }}</button>
          <button @click="cancel">{{ $t('cancel') }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Modal from '@/components/Modal.vue';

export default {
  name: 'language-selector',
  components: { Modal },
  data() {
    return {
      showMulti: false,
      isModalOpen: false,
      updateLang: null,
    };
  },
  computed: {
    ...mapState('global', ['programName']),
    languageOptions() {
      return this.$store.state.languages;
    },
    selectedLanguage() {
      return this.$store.state.selectedLanguage;
    },
  },
  methods: {
    ...mapActions(['updateLanguage']),
    toggleMulti() {
      this.showMulti = !this.showMulti;
    },
    updateLangOption(language) {
      this.isModalOpen = true;
      this.updateLang = language;
    },
    confirmLang() {
      this.updateLanguage(this.updateLang);
      this.isModalOpen = false;
      this.updateLang = null;
    },
    cancel() {
      this.updateLang = null;
      this.isModalOpen = false;
    },
    onClickOutside() {
      if (this.showMulti) {
        this.toggleMulti();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.language {
  cursor: pointer;
  .lang-container {
    position: absolute;
    top: 25px;
    left: 0px;
    background: $primary-white;
    width: 100%;
    box-shadow: 0px 2px 6px #0000001a;

    .lang {
      padding: 10px 0px 10px 20px;
    }
    .active {
      background: $primary;
      color: $primary-white;
      font-weight: bold;
    }
  }
}
.multiselect ::v-deep {
  .multiselect {
    &__tags {
      font-size: 16px;
      line-height: 1;
      border-radius: 3px;
    }
  }
}
.modal-button-container {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  .submit {
    margin-right: 20px;
  }
}
</style>
